import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ApilistService } from 'src/app/services/apilist.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ind-college',
  standalone: true,
  imports: [
    CommonModule, // for *ngIf, *ngFor, ngStyle
    FormsModule, // for [(ngModel)]
    ReactiveFormsModule, // for [formGroup], formControlName
  ],
  templateUrl: './ind-college.component.html',
  styleUrls: ['./ind-college.component.scss'],
})
export class IndCollegeComponent implements OnInit {
  display = 'none';
  displayImages = 'none';
  displayDelete = 'none';
  displayfeesDelete = 'none';
  displayVideo = 'none';
  displayfeesImages = 'none';
  displayVideoDelete = 'none';
  individualCollege: any;
  collegeData: any;
  collegeid: any;
  courseaddForm: UntypedFormGroup;
  collegeImagesForm: UntypedFormGroup;
  videoForm: UntypedFormGroup;

  scopeIdArray = [];

  showAdd = false;
  showEdit = false;
  showErr = false;
  deleteErr: any;

  videoUrl: any;

  newData: any[] = [];

  isShowAll: boolean = false;
  imageData: any[];
  videos: any[];
  videoData: any[] = [];
  courses: any[];
  courseData: any[] = [];
  te: any;

  error_messages = {
    courseVal: [{ type: 'required', message: 'please enter course.' }],
    feesVal: [{ type: 'required', message: 'please enter fees.' }],
    trustFeesVal: [{ type: 'required', message: 'please enter trust fees.' }],
    colgImg: [{ type: 'required', message: 'please enter image.' }],
    imageVal: [{ type: 'required', message: 'please enter image.' }],
    videoVal: [{ type: 'required', message: 'please enter video.' }],
  };
  scopeData: any;
  images = [];
  id: any;
  fees_id: any;
  fileToUpload: File;
  imageUrl: any;
  feesData: any[];
  newDatas: any[] = [];

  constructor(
    public commonservice: CommonService,
    public formBuilder: UntypedFormBuilder,
    public utils: ApilistService,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService
  ) {
    this.imageUrl = 'assets/tenant-avatar.jpg';

    this.courseaddForm = this.formBuilder.group({
      courseVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      feesVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      trustFeesVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    this.collegeImagesForm = this.formBuilder.group({
      colgImg: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    this.videoForm = this.formBuilder.group({
      imageVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      videoVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let user = JSON.parse(localStorage.getItem('collegeDetails'));
    this.collegeData = JSON.parse(user);
    // console.log("College data", this.collegeData);
    if (this.collegeData.image == null || this.collegeData.image == undefined) {
      this.collegeData.image = 'assets/avatar.png';
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.commonservice
      .getMethod(
        `individualcollegedetails?college_id=${this.collegeData.id}`,
        ''
      )
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.individualCollege = resp.data;
          // console.log("Whole Data", this.individualCollege);

          for (let i = 0; i <= this.individualCollege.length; i++) {
            this.imageData = this.individualCollege[i].college_images;
            this.videos = this.individualCollege[i].videos;
            this.feesData = this.individualCollege[i].college_fees_images;
            this.courses = this.individualCollege[i].courses;
            this.courseData = this.courses.slice(0, 3);
            // console.log("Data", this.courseData);
            this.videoData = this.videos.slice(0, 4);
            this.newData = this.imageData.slice(0, 4);
            this.newDatas = this.feesData.slice(0, 4);

            console.log('this.newdata', this.newDatas);
          }
        }
      });

    // Get Scope \\
    const servicePathscope = this.utils.getApiConfigs('scope');
    this.commonservice
      .invokeService(servicePathscope[1].method, servicePathscope[1].path, '')
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.scopeData = resp.data;
          // console.log("Scope", this.scopeData);
        }
      });
  }

  viewCourse() {
    if (!this.isShowAll) {
      this.courseData = this.courses;
    } else {
      this.courseData = this.courses.slice(0, 3);
    }
    this.isShowAll = !this.isShowAll;
  }

  viewImages() {
    if (!this.isShowAll) {
      this.newData = this.imageData;
    } else {
      this.newData = this.imageData.slice(0, 4);
    }
    this.isShowAll = !this.isShowAll;
  }

  viewfeesImages() {
    if (!this.isShowAll) {
      this.newDatas = this.feesData;
    } else {
      this.newDatas = this.feesData.slice(0, 4);
    }
    this.isShowAll = !this.isShowAll;
  }

  viewVideos() {
    if (!this.isShowAll) {
      this.videoData = this.videos;
    } else {
      this.videoData = this.videos.slice(0, 4);
    }
    this.isShowAll = !this.isShowAll;
  }

  handleFileInput(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  addCourse() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayImages = 'none';
    this.displayDelete = 'none';
    this.displayfeesDelete = 'none';
    this.displayVideo = 'none';
    this.displayfeesImages = 'none';
    this.displayVideoDelete = 'none';
  }

  addCourses() {
    this.spinner.show();
    for (var i = 0; i < this.scopeData.length; i++) {
      if (this.scopeData[i].id != null && this.scopeData[i].check) {
        this.scopeIdArray.push({
          college_id: this.collegeData.id,
          scope_id: this.scopeData[i].id,
          fees: this.scopeData[i].fees,
          trust_fees: this.scopeData[i].trustFees,
        });
      }
    }
    // for(var i = 0; i < this.scopeData.length; i++){
    //   if((this.scopeData[i].id != null)&&(this.scopeData[i].check)){
    //     this.scopeIdArray.push({scope_id: this.scopeData[i].id, fees: this.scopeData[i].fees, trust_fees: this.scopeData[i].trustFees});
    //   }
    // }
    let payload = {
      scopes: this.scopeIdArray,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('collegedetails');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course Details added Successfully');
          this.display = 'none';
          // this.collegeDetailsForm.reset();
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  addImages() {
    this.displayImages = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  addfeesImages() {
    this.displayfeesImages = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  addCollegeImages() {
    // console.log("Images", this.images);
    this.spinner.show();
    let payload = {
      college_id: this.collegeData.id,
      user_image: this.images,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('collegeimage');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Images Added Successfully');
          this.displayImages = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  addCollegefeesImages() {
    // console.log("Images", this.images);
    this.spinner.show();
    let payload = {
      college_id: this.collegeData.id,
      image: this.images,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('colgfeesimg');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Images Added Successfully');
          this.displayImages = 'none';
          this.images = [];
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  deleteImage(data) {
    // console.log("Data", data);
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.college_image_id;
  }

  deletefeesImage(data) {
    // console.log("Data---------------------", data);
    this.displayfeesDelete = 'block';
    this.deleteErr = '';
    this.fees_id = data.college_fees_id;
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecollegeimage');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Image deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.message);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }

  deletefees() {
    this.spinner.show();
    let payload = {
      id: this.fees_id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('delfeesimg');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Image deleted successfully');
          this.displayfeesDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.message);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }

  addVideos() {
    this.displayVideo = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  handleImageFileInput(file: FileList) {
    this.fileToUpload = file.item(0);

    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
      // console.log("img", this.imageUrl);
    };

    reader.readAsDataURL(this.fileToUpload);
  }

  addVideo() {
    this.spinner.show();
    let payload = {
      college_id: this.collegeData.id,
      url: this.videoUrl,
      user_image: this.imageUrl,
    };

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('videourl');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Video added Successfully');
          this.displayVideo = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  deleteVideo(data) {
    this.displayVideoDelete = 'block';
    // console.log("data", data);
    this.id = data.Video_id;
  }

  videoDelete() {
    this.spinner.show();
    let payload = {
      id: this.collegeData.id,
    };

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecollegevideo');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Video URL deleted successfully');
          this.displayVideoDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.data;
        }
      });
  }
}
